import React from "react";

import { Badge } from "@mui/material";

import { IBaseBadge } from "./interface";
import { Container } from "./styles";

export const BaseBadge: React.FC<IBaseBadge> = ({
  id,
  content,
  color = "primary",
}) => {
  if (content !== undefined) {
    return (
      <Container>
        <Badge
          className="badge_color"
          id={id}
          data-testid={id}
          color="primary"
          badgeContent={<label>{content}</label>}
        />
      </Container>
    );
  }

  return <Badge id={id} data-testid={id} color={color} variant="dot" />;
};
